import { Outlet } from 'react-router-dom';

import * as St from './Layout.styles';
import { useLayoutNextButtonVisibility } from './hooks/useLayoutNextButtonVisibility';

import { useLayoutPaddingContext } from '~/legacy/easy-estimator-page/context/layoutPaddingContext';
import NextStepButton from '~atoms/NextStepButton';
import NavStepper from '~molecules/NavStepper';
import Header from '~organisms/Header';
import NavBar from '~organisms/NavBar';
import OutageBanner from '~organisms/OutageBanner';

const Layout = () => {
  const shouldShowNextButton = useLayoutNextButtonVisibility();
  const { isPaddingDisabled } = useLayoutPaddingContext();

  return (
    <St.Container>
      <OutageBanner />
      <Header>
        <NavBar>
          <NavStepper />
        </NavBar>
      </Header>

      <St.MainContent $paddingDisabled={isPaddingDisabled}>
        <Outlet />

        {shouldShowNextButton && (
          <St.NextStepContainer>
            <NextStepButton />
          </St.NextStepContainer>
        )}
      </St.MainContent>
    </St.Container>
  );
};

export default Layout;
